var validBusLicense = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传营业执照'));
    }
};
var validOpeningPermit = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传开户许可证'));
    }
};
var validCardPositive = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传身份证正面照'));
    }
};
var validCardNegative = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传身份证反面照'));
    }
};
var validHandHold = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传手持身份证照'));
    }
};


var validStoreDoor = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传门店门头照'));
    }
};
var validStoreEnvironment = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传店内环境照片'));
    }
};
var validMerchantContract = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传商户合同文件'));
    }
};
var validStatementSettlement = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上结算声明'));
    }
};
var validOtherDocuments = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传其他文件'));
    }
};
var validHandwrittenSignature = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传手写签名'));
    }
};
var validSigningDocuments = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传签约文件照片'));
    }
};
var validStoreCashier = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传门店收银台'));
    }
};
var validSecurities = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        return callback(new Error('请上传经营场所产权证明/租赁合同'));
    }
};
export default { // 验证
    mcc: [
        { required: true, message: '请选择经营类别', trigger: 'change' },
    ],
    business: [
        { required: true, message: '请填写经营范围', trigger: 'change' },
    ],
    union_pay_code: [
        { required: true, message: '请选择经营地址', trigger: 'change' },
    ],
    addr_detail: [
        { required: true, message: '请填写经营地址', trigger: 'change' },
    ],
    mch_name: [
        { required: true, message: '请填写商户名称', trigger: 'blur' },
    ],
    legal_person: [
        { required: true, message: '请填写法人姓名', trigger: 'blur' },
    ],
    legal_phone: [
        { required: true, message: '请填写法人手机号', trigger: 'blur' },
    ],
    id_card: [
        { required: true, message: '请填写证件号', trigger: 'blur' },
    ],
    credit_code: [
        { required: true, message: '请填写统一社会信用代码', trigger: 'blur' },
    ],
    bus_license_valid_sdate: [
        { required: true, message: '请选择营业执照有效期', trigger: 'blur' },
    ],
    card_valid_sdate: [
        { required: true, message: '请选择身份证有效期', trigger: 'blur' },
    ],
    account_name: [
        { required: true, message: '请填写银行账户名称', trigger: 'change' },
    ],
    account_type: [
        { required: true, message: '请选择账户类型', trigger: 'change' },
    ],
    bank_id: [
        { required: true, message: '请选择银行名称', trigger: 'change' },
    ],
    branch_bank_id: [
        { required: true, message: '请选择支行名称', trigger: 'change' },
    ],
    line_num: [
        { required: true, message: '请填写联行号', trigger: 'change' },
    ],
    bank_code: [
        { required: true, message: '请填写银行账号', trigger: 'blur' },
    ],
    bus_license_img: [
        { required: true, validator: validBusLicense, trigger: 'change' },
    ],
    // opening_permit_img: [
    //     { required: true, validator: validOpeningPermit, trigger: 'change' },
    // ],
    card_positive_img: [
        { required: true, validator: validCardPositive, trigger: 'change' },
    ],
    card_negative_img: [
        { required: true, validator: validCardNegative, trigger: 'change' },
    ],
    card_hand_hold_img: [
        { required: true, validator: validHandHold, trigger: 'change' },
    ],
    // settle_card_img: [
    //     { required: true, validator: validCardNegative, trigger: 'change' },
    // ],
 
    store_door_img: [
        { required: true, validator: validStoreDoor, trigger: 'change' },
    ],
    store_environment_img: [
        { required: true, validator: validStoreEnvironment, trigger: 'change' },
    ],
    merchant_contract_img: [
        { required: true, validator: validMerchantContract, trigger: 'change' },
    ],
    statement_settlement_img: [
        { required: true, validator: validStatementSettlement, trigger: 'change' },
    ],
    other_documents_img: [
        { required: true, validator: validOtherDocuments, trigger: 'change' },
    ],
    handwritten_signature_img: [
        { required: true, validator: validHandwrittenSignature, trigger: 'change' },
    ],
    signing_documents_img: [
        { required: true, validator: validSigningDocuments, trigger: 'change' },
    ],
    store_cashier_img: [
        { required: true, validator: validStoreCashier, trigger: 'change' },
    ],
    securities_img: [
        { required: true, validator: validSecurities, trigger: 'change' },
    ],
}